// TEST-ONLY: no inactivity auto-logout on the TEST build.
//
// Loaded by src/idleLogout.js only when VUE_APP_SILENT_TOKEN_RENEWAL === 'on' (.env.test).
// The LIVE build must never contain this file: scripts/check-bundle-endpoint.js fails a
// "live" build if MARKER appears in dist/js.

export const MARKER = 'mbp-test-no-idle-logout'

let announced = false

export default function testNoIdleLogout () {
  if (!announced) {
    announced = true
    // eslint-disable-next-line no-console
    console.info('[' + MARKER + '] TEST build: the 60-minute inactivity auto-logout is off')
  }
}
